import {newSimulation, NewSimulation} from "./new-simulation/NewSimulationComponent";
import {simulationData, SimulationData} from "./simulation-data/TradeSimulationDataComponent";
import {simulationResult, SimulationResult} from "./simulation-result/TradeSimulationResultComponent";
import {simulationTradeRow, SimulationTradeRow} from "./simulation-data/trade/SimulationTradeComponent";
import {newSimulationTrade, NewSimulationTrade} from "./simulation-data/new-trade/TradeSimulationNewTradeComponent";
import {performanceChart, PerformanceChart} from "./performance-chart/SimulationPerformanceChartComponent";
import {optionSelect, OptionSelect} from "./option-select/OptionSelectComponent";
import {chartRange, ChartRange} from "./chart-range-selector/ChartRangeSelectorComponent";
import {AsAsSummary, asAtSummary} from "./as-at-summary/AsAtSummaryComponent";

import StockChart from "./stock-chart";

export default angular.module("tfApp.trade-simulator.components", [StockChart])
                      .component(NewSimulation, newSimulation())
                      .component(SimulationData, simulationData())
                      .component(SimulationTradeRow, simulationTradeRow())
                      .component(NewSimulationTrade, newSimulationTrade())
                      .component(SimulationResult, simulationResult())
                      .component(PerformanceChart, performanceChart())
                      .component(OptionSelect, optionSelect())
                      .component(ChartRange, chartRange())
                      .component(AsAsSummary, asAtSummary())
                      .name;
